import { register } from 'larasnap';
import MagicLogin from './MagicLogin';

register(MagicLogin);
